import type { EventType, OptionsDocument } from 'paintscout'
import type { AutomationOption, AutomationTriggerType } from '..'

export function getAutomations({
  options,
  forOptions = false,
  types = []
}: {
  options: OptionsDocument
  forOptions?: boolean
  types?: EventType[]
}): AutomationOption[] {
  const translatedTypes: AutomationTriggerType[] = translateTypes(types)
  if (options && options?.options?.automations) {
    const { automations } = options.options
    const automationList = options.options.automations.order
      .map((automationId) => {
        const automation = automations.values[automationId]
        if (!automation || automation.deleted || (!forOptions && !automation.active)) {
          return null
        }
        if (!forOptions && (!translatedTypes.length || !translatedTypes.includes(automation.trigger.type))) {
          return null
        }
        return automation
      })
      .filter(Boolean)
    return automationList.sort((a, b) => {
      const aDate = a.updated ?? a.created
      const bDate = b.updated ?? b.created
      return bDate - aDate // Descending: most recent first
    })
  }

  return []
}

function translateTypes(types: EventType[]): AutomationTriggerType[] {
  return types.reduce((acc, currentType) => {
    if (currentType === 'quote-status-changed') {
      acc.push('quote-status-changed', 'invoice-status-changed')
      return acc
    }

    return acc
  }, [])
}
